export const SIDE_MENU_ANIMATION_DURATION = 200

export const getSidebarStyles = (isOpen, isRtl) => {
    return {
        iconStyle: {
            minWidth: 0,
            mr: isOpen ? 3 : 'auto',
            px: isOpen ? 2 : 0,
        },
        textStyle: {
            opacity: isOpen ? 1 : 0,
            textAlign: isRtl ? 'right' : 'left',
        },
    }
}

export const getMobileSideMenuSx = (displayMode) => {
    return {
        mx: 0,
        px: 0,
        display: {xs: displayMode, sm: 'none'},
        cursor: 'pointer',
    }
}

export const getSearchBoxStyles = (displayMode) => {
    return {
        searchBoxSx: {
            width: {xs: '100%', md: 300},
            display: {
                lg: 'flex',
                md: displayMode,
                xs: 'flex',
            },
            margin: 'auto',
            // px: 4,
        },
        searchBarSx: {
            width: {xs: '100%', md: 300},
            display: {xs: displayMode, sm: displayMode},
        },
    }
}
export const getAdvenceSearchAutoCompeteSx = (arrowOffset) => {
    return {
        width: 300,
        margin: '10px',
        '& > div': {
            position: 'static',
        },
        '& .MuiOutlinedInput-root': {p: 0},
        '& *': {color: 'black'},
        '& .MuiAutocomplete-popupIndicator': {
            right: `${arrowOffset}px`,
        },
        '& .MuiAutocomplete-hasPopupIcon': {
            paddingRight: 0,
        },
        '& .MuiAutocomplete-clearIndicator': {
            position: 'absolute',
            right: `${arrowOffset ? arrowOffset + 50 : 0}px`,
        },
    }
}
export const getAutoCompeteSx = (arrowOffset) => {
    return {
        width: 300,
        '& > div': {
            position: 'static',
        },
        '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
            border: 'none',
        },
        '& .MuiOutlinedInput-root': {p: 0},
        '& *': {
            color: 'black',
            border: 'none',
        },
    }
}

export const getCheckboxStyle = (color) => {
    return {
        color,
        '&.Mui-checked': {
            color,
        },
    }
}

const getHoverButtonSx = (color) => {
    return {
        '&:hover': {
            color,
            backgroundColor: 'transparent',
        },
    }
}

const Styles = {
    SIDE_PADDING: '20px',
    ROW_PADDING: '10px',
    DRAWER_WIDTH: 240,
    DRAWER_WIDTH_CLOSED: 65,
    BUTTON_HOVER_SX: getHoverButtonSx('#4ABCC1'),
    DELETE_HOVER_SX: getHoverButtonSx('red'),
    LIKE_HOVER_SX: getHoverButtonSx('#7399fb'),
    DANCE_CARD_HEADER_SX: {
        width: 40,
        height: 40,
        fontSize: 15,
        bgcolor: 'gray',
        marginLeft: 3,
    },
    CROP_CONTAINER_SX: {
        background: '#333',
        position: 'relative',
        height: 400,
        width: 'auto',
        minWidth: {sm: 500},
    },
    SEARCH_ICON_SX: {
        fontSize: '30px',
        m: 'auto 10px',
        md: {display: 'none'},
    },
    CROP_BUTTON_SX: {
        display: 'flex',
        gap: 2,
        flexWrap: 'wrap',
    },
    MENU_ANCHOR_ORIGIN: {
        vertical: 'bottom',
        horizontal: 'left',
    },
    PAGE_HEADER_SX: {
        flexGrow: 1,
        display: 'flex',
    },
    ACTION_BUTTON: {
        height: '50px',
        width: '50px',
    },
    PROFILE_IMAGE_BUTTON: {
        width: 40,
        height: 40,
    },
}

export default Styles
